import { render } from "./projectCards.vue?vue&type=template&id=ccb26d1a"
import script from "./projectCards.vue?vue&type=script&lang=js"
export * from "./projectCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__